import { render, staticRenderFns } from "./CollectFilterLink.vue?vue&type=template&id=733c41ff&scoped=true&"
import script from "./CollectFilterLink.vue?vue&type=script&lang=js&"
export * from "./CollectFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733c41ff",
  null
  
)

export default component.exports